export const EMPLOYEE_ROLE_ORDER = ['ADMIN', 'MANAGER', 'DISPATCHER', 'EXECUTOR', 'OBSERVER'] as const;
export type EmployeeRole = typeof EMPLOYEE_ROLE_ORDER[number];
export type PortalRole = EmployeeRole | 'CLIENT';
export type RoleCarrier = {
  userType?: string | null;
  role?: string | null;
  roles?: readonly string[] | null;
};

const PORTAL_ROLE_ORDER: readonly PortalRole[] = [...EMPLOYEE_ROLE_ORDER, 'CLIENT'];
const KNOWN_ROLES = new Set<string>(PORTAL_ROLE_ORDER);

export function userRoles(user: RoleCarrier | null | undefined): PortalRole[] {
  if (!user) return [];
  if (user.userType === 'CLIENT') return ['CLIENT'];
  const supplied = user.roles?.length ? user.roles : [user.role];
  const roles = [...new Set(supplied
    .map(role => String(role ?? '').trim().toUpperCase())
    .filter(role => KNOWN_ROLES.has(role) && role !== 'CLIENT'))] as EmployeeRole[];
  if (!roles.length) roles.push('EXECUTOR');
  return roles.sort((left, right) => PORTAL_ROLE_ORDER.indexOf(left) - PORTAL_ROLE_ORDER.indexOf(right));
}

export function userHasRole(user: RoleCarrier | null | undefined, role: PortalRole | string) {
  return userRoles(user).includes(String(role).toUpperCase() as PortalRole);
}

export function userHasAnyRole(user: RoleCarrier | null | undefined, roles: readonly string[]) {
  const assigned = new Set(userRoles(user));
  return roles.some(role => assigned.has(String(role).toUpperCase() as PortalRole));
}

export function primaryUserRole(user: RoleCarrier | null | undefined): PortalRole {
  return userRoles(user)[0] ?? 'EXECUTOR';
}
